import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.define-property";
import { __assign, __awaiter, __generator, __values } from "tslib";
import Vue from 'vue';

var AddressItem =
/** @class */
function () {
  function AddressItem(item) {
    this.id = item.id;
    this.name = item.name;
    this.mobile = item.mobile;
    this.tag = item.tag;
    this.district_id = item.district_id;
    this.district = item.district;
    this.detail = item.detail;
    this.is_default = item.is_default;
  }

  Object.defineProperty(AddressItem.prototype, "address", {
    get: function get() {
      return this.district.join('') + this.detail;
    },
    enumerable: false,
    configurable: true
  });
  return AddressItem;
}();

function parse(raw) {
  var item = __assign(__assign({}, raw), {
    district_id: [raw.district1_id, raw.district2_id, raw.district3_id].filter(function (_) {
      return _;
    }),
    district: [raw.district1, raw.district2, raw.district3].filter(function (_) {
      return _;
    })
  });

  return new AddressItem(item);
}

function format(item) {
  var raw = __assign(__assign({}, item), {
    district1: item.district[0],
    district2: item.district[1],
    district3: item.district[2],
    district1_id: item.district_id[0],
    district2_id: item.district_id[1],
    district3_id: item.district_id[2]
  });

  return raw;
}

var m = {
  namespaced: true,
  state: {
    defaultAddress: null,
    list: null,
    pendingDetail: new AddressItem({
      id: 0,
      name: '',
      mobile: '',
      tag: '',
      district_id: [],
      district: [],
      detail: '',
      is_default: true
    }),
    detail: {},
    selectAddress: null
  },
  mutations: {
    setDefault: function setDefault(state, address) {
      state.defaultAddress = address.id;
      Vue.set(state.detail, address.id, address);
    },
    setList: function setList(state, list) {
      var e_1, _a;

      var ids = [];

      try {
        for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
          var item = list_1_1.value;
          ids.push(item.id);
          Vue.set(state.detail, item.id, item);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (list_1_1 && !list_1_1.done && (_a = list_1["return"])) _a.call(list_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }

      state.list = ids;
    },
    setPendingDetail: function setPendingDetail(state, detail) {
      state.pendingDetail = detail;
    },
    setDetail: function setDetail(state, _a) {
      var addressId = _a.addressId,
          detail = _a.detail;
      Vue.set(state.detail, addressId, detail);
    },
    removeDetail: function removeDetail(state, _a) {
      var addressId = _a.addressId;
      var pos = (state.list || []).indexOf(addressId);

      if (pos >= 0) {
        state.list.splice(pos, 1);
      }
    },
    setSelectAddress: function setSelectAddress(state, info) {
      state.selectAddress = info;
    }
  },
  actions: {
    /**
     * 获取默认地址
     */
    getDefault: function getDefault(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/default_address')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0 && rdata.data) {
                context.commit('setDefault', parse(rdata.data));
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取默认地址
     */
    getList: function getList(context, _a) {
      var forceUpdate = (_a === void 0 ? {} : _a).forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (context.state.list && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/address')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setList', rdata.data.map(function (item) {
                  return parse(item);
                }));
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取默认地址
     */
    getDetail: function getDetail(context, _a) {
      var addressId = _a.addressId,
          forceUpdate = _a.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (context.state.detail[addressId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/address_detail', {
                params: {
                  id: addressId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setDetail', {
                  addressId: addressId,
                  detail: parse(rdata.data)
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 创建地址
     */
    create: function create(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/address', format(context.state.pendingDetail))];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.dispatch('getList', {
                  forceUpdate: true
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 更新地址
     */
    update: function update(context, _a) {
      var addressId = _a.addressId;
      return __awaiter(this, void 0, void 0, function () {
        var detail, response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              detail = context.state.detail[addressId];
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/address', format(detail))];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.dispatch('getList', {
                  forceUpdate: true
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 删除地址
     */
    "delete": function _delete(context, _a) {
      var addressId = _a.addressId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios["delete"]('/api/v1/user/address', {
                data: {
                  id: addressId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('removeDetail', {
                  addressId: addressId
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;